import script from "./Folder.vue?vue&type=script&setup=true&lang=ts"
export * from "./Folder.vue?vue&type=script&setup=true&lang=ts"

import "./Folder.vue?vue&type=style&index=0&id=6255241f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6255241f"]])

export default __exports__